<script lang="ts">
  import type { Verification, VerificationState } from "./types";
  import ConfirmDetail from "./ConfirmDetail.svelte";
  import FooterButtons from "../../components/workflow/FooterButtons.svelte";
  import ContinueButton from "../../components/workflow/ContinueButton.svelte";

  let {
    verifications: propVerifications,
    explanation,
    goToUpload,
    errors,
  }: {
    verifications: Verification[];
    explanation: string;
    goToUpload: ()=>void;
    errors: { [key: string]: string } | undefined;
  } = $props();

  // svelte-ignore state_referenced_locally
  let verifications = $state<VerificationState[]>(propVerifications.map((v) => { return { ...v, values: [] }}));
</script>

<h2 class="ui-title">Enter your booking details</h2>

<p>
  {explanation} If you have your booking confirmation email,
  <button type="button" class="link text-primary" onclick={goToUpload}>
    share it with us
  </button>.
</p>

{#each verifications as verification, index}
  {@const { existing, name, label, pluralLabel, articleLabel, instruction, autocomplete, required, values } = verification }
  <div class="{index !== 0 ? "pt-4 border-t" : ""} pb-6">
    {#each values as value}<input name="{name}[]" type="hidden" {value} />{/each}

    <div class="mb-4">
      <p class="font-semibold mb-2">Add any {pluralLabel}</p>
      {#if instruction}<p>{instruction}</p>{/if}
    </div>

    <ConfirmDetail
      existing={existing}
      items={values}
      set={items => verification.values = items}
      type={name === "email" ? "email" : "text"}
      placeholder="Add {articleLabel}"
      error={errors?.[name]}
      open={index === 0}
      {label} {autocomplete} {required}
    />
  </div>
{/each}

<FooterButtons>
  <ContinueButton type="submit" label="Done" />
</FooterButtons>
